import { Link } from 'react-router-dom'
import StatusPill from '../../../../components/badges/StatusPill'
import { PROFILE_OVERVIEW } from '../../mockData'
import { WIREFRAME_PATHS } from '../../routes'

export default function OverviewTab() {
    return (
        <div className="rounded-lg border border-gray-200 bg-white">
            <div className="border-b border-gray-100 px-4 py-2.5 text-[13px] font-semibold text-gray-900">
                Profile overview
            </div>
            <dl className="grid grid-cols-2 gap-x-6 gap-y-3 px-4 py-3 sm:grid-cols-3">
                <div>
                    <dt className="text-xs text-gray-800">Platform</dt>
                    <dd className="text-sm text-gray-900">{PROFILE_OVERVIEW.platform}</dd>
                </div>
                <div>
                    <dt className="text-xs text-gray-800">Team</dt>
                    <dd className="text-sm">
                        <Link
                            to={WIREFRAME_PATHS.teamConfig}
                            className="text-arwen-700 hover:underline"
                        >
                            {PROFILE_OVERVIEW.teamName}
                        </Link>
                    </dd>
                </div>
                <div>
                    <dt className="text-xs text-gray-800">Status</dt>
                    <dd className="text-sm">
                        <StatusPill tone="safe">{PROFILE_OVERVIEW.status}</StatusPill>
                    </dd>
                </div>
                <div>
                    <dt className="text-xs text-gray-800">Created by</dt>
                    <dd className="text-sm text-gray-900">{PROFILE_OVERVIEW.createdBy}</dd>
                </div>
                <div>
                    <dt className="text-xs text-gray-800">Created on</dt>
                    <dd className="text-sm text-gray-900">{PROFILE_OVERVIEW.createdOn}</dd>
                </div>
                <div>
                    <dt className="text-xs text-gray-800">Last activity</dt>
                    <dd className="text-sm text-gray-900">{PROFILE_OVERVIEW.lastActivity}</dd>
                </div>
                <div>
                    <dt className="text-xs text-gray-800">Total comments</dt>
                    <dd className="text-sm text-gray-900">
                        {PROFILE_OVERVIEW.totalComments.toLocaleString()}
                    </dd>
                </div>
                <div>
                    <dt className="text-xs text-gray-800">Moderated</dt>
                    <dd className="text-sm text-gray-900">
                        {PROFILE_OVERVIEW.moderatedComments.toLocaleString()}
                    </dd>
                </div>
            </dl>
        </div>
    )
}
